import {createSelector} from '@reduxjs/toolkit';

import {TAppState} from 'store/config/types';

import {AIS3_SLICE} from '../ais-slice-constants';

const selectAisSliceState = (state: TAppState) => state[AIS3_SLICE];

export const selectCommentsRequestTableData = createSelector(
    selectAisSliceState,
    ({aisCommentsRequest}) => ({
        aisCommentsRequestTable: aisCommentsRequest.aisCommentsRequestTable,
        recordsTotal: aisCommentsRequest.recordsTotal,
    }),
);

export const selectCommentsRequestRowsTableData = createSelector(
    selectAisSliceState,
    ({aisCommentsRequest}) => aisCommentsRequest.aisInspectorCommentInfo,
);
